import { render } from "./indexAndroidPrivacyPolicy.vue?vue&type=template&id=e0802a34&scoped=true&ts=true"
import script from "./indexAndroidPrivacyPolicy.vue?vue&type=script&lang=ts"
export * from "./indexAndroidPrivacyPolicy.vue?vue&type=script&lang=ts"

import "./indexAndroidPrivacyPolicy.vue?vue&type=style&index=0&id=e0802a34&scoped=true&lang=scss"

import exportComponent from "D:\\project\\H5-NEW\\H5\\APP内嵌H5\\rs-h5app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0802a34"]])

export default __exports__